import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "cta-banner-wrapper" };
const _hoisted_2 = { class: "yellow-background" };
const _hoisted_3 = { class: "container" };
const _hoisted_4 = { class: "cta-banner" };
const _hoisted_5 = { class: "banner-image" };
const _hoisted_6 = { class: "image-placeholder" };
const _hoisted_7 = ["src"];
import { useAssets } from '../composables/useAssets';
export default /*@__PURE__*/ _defineComponent({
    __name: 'StaticBannerWithCTA',
    setup(__props) {
        const { assetUrl } = useAssets();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "background-image-section" }, [
                    _createElementVNode("img", { src: "/images/trade-site/banner-top.png" })
                ], -1)),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("img", {
                                        src: _unref(assetUrl)('/images/trade-site/oil-bottles-2.png'),
                                        alt: ""
                                    }, null, 8, _hoisted_7)
                                ])
                            ]),
                            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "banner-content" }, [
                                _createElementVNode("h2", { class: "banner-title" }, " Driven by innovation and committed to keeping the world moving "),
                                _createElementVNode("p", { class: "banner-description" }, " Find the right Duckhams oil for your vehicle in seconds. Our advanced lubricant technology is designed to protect engines, enhance efficiency, and keep you moving - mile after mile. ")
                            ], -1))
                        ])
                    ])
                ])
            ]));
        };
    }
});
